<script setup>
import { computed } from 'vue';

const props = defineProps({
  planAvailable: {
    type: Number,
    default: 0,
  },
  metaDailyLimit: {
    type: Number,
    default: 0,
  },
  sendsToday: {
    type: Number,
    default: 0,
  },
  remainingToday: {
    type: Number,
    default: 0,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const isUnlimited = computed(() => props.metaDailyLimit === -1);

const dailyPercentage = computed(() => {
  if (isUnlimited.value) return 0;
  if (props.metaDailyLimit === 0) return 100;
  return Math.min((props.sendsToday / props.metaDailyLimit) * 100, 100);
});

const progressBarColor = computed(() => {
  if (dailyPercentage.value > 90) return 'bg-n-ruby-9';
  if (dailyPercentage.value > 75) return 'bg-n-amber-9';
  return 'bg-n-teal-9';
});
</script>

<template>
  <div class="p-4 border rounded-xl border-n-slate-3 bg-n-alpha-1">
    <div v-if="isLoading" class="flex items-center justify-center h-20">
      <span class="text-sm text-n-slate-11">Calculando límites en vivo...</span>
    </div>
    <div v-else class="flex flex-col gap-4">
      <div class="flex items-center justify-between">
        <h4 class="text-sm font-semibold text-n-slate-12">Monitoreo de Límites</h4>
        <div class="flex items-center gap-1.5 text-xs font-medium text-n-teal-11 bg-n-teal-3 px-2 py-0.5 rounded-full">
          <span class="i-lucide-activity text-[10px]" /> En vivo
        </div>
      </div>
      
      <!-- Plan Limits -->
      <div class="flex items-center justify-between p-3 rounded-lg bg-n-slate-2">
        <span class="text-xs font-medium text-n-slate-11">Mensajes del Plan Disponibles</span>
        <span class="text-sm font-bold text-n-slate-12">{{ planAvailable.toLocaleString() }}</span>
      </div>

      <!-- Meta Daily Limits -->
      <div class="flex flex-col gap-2">
        <div class="flex items-center justify-between text-xs">
          <span class="font-medium text-n-slate-11">Consumo Diario (Meta/Evolution)</span>
          <span class="font-bold text-n-slate-12">
            {{ sendsToday.toLocaleString() }} / {{ isUnlimited ? 'Ilimitado' : metaDailyLimit.toLocaleString() }}
          </span>
        </div>
        <div v-if="!isUnlimited" class="w-full h-2.5 overflow-hidden rounded-full bg-n-slate-3">
          <div
            class="h-full transition-all duration-700 ease-out rounded-full"
            :class="progressBarColor"
            :style="{ width: `${dailyPercentage}%` }"
          />
        </div>
      </div>
    </div>
  </div>
</template>
